import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import cx from 'classnames';
import toWebpImage from '@src/utils/to-webp-image';

import PassportScreenStore from '@src/pages/main/components/passport-screen/store';

const styles = require('./index.less');

const PassportScreen = ({ store }) => {
  return (
    <div className={cx(styles.passportScreenRoot, store.isActive && styles.passportScreenRootAct)}>
      <div className={styles.content}>
        <div className={styles.mechaGroup}>
          <div className={cx(styles.mechaItem, styles.MS)} />
          <div className={cx(styles.mechaItem, styles.ARF)} />
          <div className={cx(styles.mechaItem, styles.HL)} />
        </div>
        <div className={styles.sloganGroup}>
          <div className={styles.slogan} />
          <div className={styles.subTitle} />
        </div>
        <div className={styles.gifts}>
          <img src={toWebpImage(require('./images/gifts.png'))} alt="gifts" />
        </div>
      </div>
      <div className={styles.bgDecorate}>
        <img src={toWebpImage(require('./images/bg-decarate.png'))} alt="bg" />
      </div>
    </div>
  );
};

export default wrapStore(PassportScreen, PassportScreenStore);
